import React, { useRef } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import Favorite from './Favorite';
import { get } from 'lodash';
import {
  PARTNERS,
  EXTERNAL_PARTNERS,
  BIG_COMMERCE
} from '../../../lib/constants';
import { parseData } from '../../../lib/helpers';
import { useFptiImpression } from '../../../lib/hooks';

const CategoryToolTile = props => {
  const {
    fptiImpression,
    fpti = '',
    tool: {
      appIcon = '',
      appBody = '',
      appTitle = '',
      appKey = '',
      appFPTI = '',
      location = '',
      categoryKey = '',
      ariaLabel = '',
      PSClickUrl = '',
      rank = '',
      priorityScore = '',
      sectionKey = ''
    } = {},
    toolTileProps: {
      toolServFavorites = [],
      app,
      flatPSData = {},
      experimentation
    } = {},
    insideSection = false,
    pageLink = '',
    crossSellType = '',
    staffPickType = '',
    intentPickType = '',
    intentRank = 0,
    handleClickTool,
    path,
    hideFavorites
  } = props;
  const currentCategory = get(flatPSData, ['categories', categoryKey]) || {};
  const currentSection = get(flatPSData, ['sections', sectionKey]) || {};
  const currentFPTIPage = insideSection ? fpti : currentCategory.categoryFPTI;
  const isColoredIconsEligible = get(experimentation, 'coloredIconsExp', false);
  const fptiObj = {
    prod: appFPTI,
    pageLink: pageLink || (!crossSellType && currentFPTIPage),
    categoryRank: currentCategory.rank,
    sectionRank: currentSection.rank,
    appKey,
    rank,
    priorityScore
  };
  if (crossSellType) {
    Object.assign(fptiObj, { type: crossSellType });
  }
  if (staffPickType) {
    Object.assign(fptiObj, { type: staffPickType });
  }
  if (intentPickType) {
    Object.assign(fptiObj, { type: intentPickType, intentRank });
  }
  const ref = useRef();
  useFptiImpression(ref, () => {
    fptiImpression(fptiObj);
  });

  const handleFavoriteClick = () => {
    const {
      toolTileProps: {
        dispatch,
        toggleToolFavorite,
        tools: toolServTools
      } = {},
      tool: { appKey = '' } = {}
    } = props;

    const MTSTool = toolServTools[appKey];
    // if it can be favorited by toolserv do so
    dispatch(toggleToolFavorite(MTSTool));
  };

  const imgUrl = parseData(appIcon)[0] || {};
  const coloredImgUrl =
    isColoredIconsEligible && imgUrl.urlColored ? imgUrl.urlColored : '';

  const partnerOrMarketplace =
    EXTERNAL_PARTNERS.includes(appKey) ||
    PARTNERS.includes(appKey) ||
    appKey === BIG_COMMERCE;

  const clickToolHandler = favoriteLink => {
    const currentCategory = get(flatPSData, ['categories', categoryKey]) || {};
    const currentSection = get(flatPSData, ['sections', sectionKey]) || {};
    return handleClickTool({
      fptiLink: favoriteLink ? favoriteLink : appFPTI,
      prod: appFPTI,
      PSUrl: PSClickUrl,
      categoryKey,
      categoryRank: currentCategory.rank,
      sectionRank: currentSection.rank,
      intentRank,
      appKey,
      rank,
      priorityScore
    });
  };

  return (
    <Link
      className="undo-link-styles tile-link-wrapper add-focus-visible"
      onClick={clickToolHandler()}
      to={`${path}/${location}`}
      ref={ref}
    >
      <div className="category-tool-tile">
        <div
          className={
            !isColoredIconsEligible
              ? 'category-tool-tile-context old'
              : 'category-tool-tile-context'
          }
        >
          <div
            className={`lazyload category-tool-tile-image ${
              partnerOrMarketplace ? 'partner-marketplace' : ''
            }`}
            style={{
              background: `center center no-repeat`,
              backgroundSize:
                !isColoredIconsEligible && !partnerOrMarketplace
                  ? '80%'
                  : '100%'
            }}
            data-bg={coloredImgUrl || imgUrl.url}
          />
          <div className="category-tool-tile-title">
            <h3
              className={`${
                appTitle.replace(/\s+/g, '').length > 16 ? 'ticker ' : ''
              }${
                partnerOrMarketplace ? 'category-tool-tile-title-spacing' : ''
              }`}
            >
              {appTitle}
            </h3>
          </div>
          {!hideFavorites && (
            <Favorite
              tool={{
                favorite: toolServFavorites.includes(appKey)
              }}
              toggleFavorite={handleFavoriteClick}
              handleClickTool={clickToolHandler}
              isLoggedIn={get(app, 'fptiData.lgin', true)}
              ariaLabel={ariaLabel}
              title={appTitle}
            />
          )}
        </div>
        <div className="category-tool-tile-text">
          <p>{appBody}</p>
        </div>
      </div>
    </Link>
  );
};

CategoryToolTile.propTypes = {
  tool: PropTypes.object,
  path: PropTypes.string,
  fpti: PropTypes.string,
  fptiImpression: PropTypes.func,
  handleClickTool: PropTypes.func,
  toolTileProps: PropTypes.object,
  insideSection: PropTypes.bool,
  pageLink: PropTypes.string,
  hideFavorites: PropTypes.bool,
  crossSellType: PropTypes.string,
  staffPickType: PropTypes.string,
  intentPickType: PropTypes.string,
  intentRank: PropTypes.number
};

export default CategoryToolTile;
